import styled from 'styled-components';

import LoadingOverlay from 'dashboard/components/LoadingOverlay';
import {
  MetricsTemplateFunnel,
  MetricsVolumeSummary,
  TemplateFunnelDatum,
} from 'dashboard/models/metrics';
import TemplateFunnelChart from 'dashboard/views/DashboardInquiryAnalyticsFunnelView/TemplateFunnelChart';
import InquirySummary from 'dashboard/views/DashboardInquiryAnalyticsVolumeV2View/InquirySummary';
import Card from 'design-system/components/Card';
import { Step } from 'lib/interfaces/StepsConfig';

const MetricsCard = styled(Card)`
  position: relative;
  min-width: 720px;
`;

const SummaryCardBody = styled(Card.Body)``;

const TemplateFunnelCardBody = styled(Card.Body)`
  display: flex;
  flex-direction: column;
`;

export const metricsCard = (
  idx: number,
  loading: boolean,
  id: string,
  name: string,
  steps: Step[],
  onDeepLink: (datum: TemplateFunnelDatum, templateId: string) => void,
  templateFunnel?: MetricsTemplateFunnel,
  templateMetricsVolumeSummary?: MetricsVolumeSummary,
) => {
  return (
    <MetricsCard
      key={idx} // idx key to reuse null loading state node
      data-test='template-metrics-card'
    >
      {loading && <LoadingOverlay />}
      <SummaryCardBody>
        <InquirySummary volumeSummary={templateMetricsVolumeSummary} />
      </SummaryCardBody>

      <TemplateFunnelCardBody>
        <Card.Title data-test='template-metrics-card--name'>{name}</Card.Title>
        <TemplateFunnelChart
          data={templateFunnel?.data ?? []}
          steps={steps}
          onDeepLink={onDeepLink}
          templateId={id}
        />
      </TemplateFunnelCardBody>
    </MetricsCard>
  );
};
